module.exports = __webpack_public_path__ + "img/39.03ea8f18.jpg";